/* istanbul ignore file */
import { FieldIdentifier } from './field-identifier';

export class MapSiteDataPreview {
    id?: string;
    projectId: string;
    selectedFields: FieldIdentifier[];
    type: string;
    createdByName: string;
    createdByUserId: string;
    dateCreated: Date;
}
